
export default {
  group: 'form-group',
  input: 'form-control',
}



// WEBPACK FOOTER //
// src/common/form-elements/email-element-folder/email-element.style.js